import React, {useState, useEffect} from "react";
import styled from "styled-components";
import db from "../../firebase";
import {collection, onSnapshot, orderBy, query} from "firebase/firestore";
import UserLeavesFilter from "./UserLeavesFilter";
import UserLeavesTable from "./UserLeavesTable";

const UserLeaves = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const getData = async () => {
    const formRef = query(
        collection(db, "UserLeaves"),
        orderBy("createdDate", "desc"),
    );

    try {
      onSnapshot(formRef, (querySnapshot) => {
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setLeaveData(data);
        setFilteredData(data);
      });
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <SitePage>
        <TitleContainer>
          <h2>User Leaves</h2>
          <p>Overview of leaves</p>
        </TitleContainer>
        <UserLeavesFilter
          tableData={leaveData}
          setFilteredData={setFilteredData}
        />
        <UserLeavesTable filteredData={filteredData} />
      </SitePage>

    </>
  );
};


const SitePage = styled.div`
  padding: 30px;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12);
`;

const TitleContainer = styled.div`
  margin-bottom: 20px;
`;

export default UserLeaves;
